import {
  Component,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { CommonService } from "src/app/services/common.service";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";

@Component({
  selector: "app-confirmed-appointment",
  templateUrl: "./confirmed-appointment.component.html",
  styleUrls: ["./confirmed-appointment.component.scss"],
})
export class ConfirmedAppointmentComponent implements OnInit, OnDestroy {
  confirmedAppointmentFormGroup: FormGroup;
  formSubmitted: boolean;
  loadingFlag: boolean = false;

  constructor(
    private messageService: MessageServiceService,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private askApolloService: AskApolloService
  ) {
    this.confirmedAppointmentFormGroup = this.formBuilder.group({
      remark: ["Appointment confirmed", Validators.required],
    });
    this.confirmedAppointmentFormGroup.reset({
      remark: "Appointment confirmed",
    });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  // Own flow only — does not change Call Drop (status 18)
  UpdateConfirmedAppointmentStatus() {
    if (!this.confirmedAppointmentFormGroup.valid) {
      this.messageService.showWarning("Please Fill Fields");
      return;
    }

    this.confirmedAppointmentFormGroup.enable();
    var formDataValues = this.confirmedAppointmentFormGroup.value;
    var remark = formDataValues.remark || "Appointment confirmed";

    var leadData = JSON.parse(
      localStorage.getItem("CurrentOutBoundCallMobileNumber")
    );

    if (leadData == null || leadData == undefined) {
      var leadData1 = JSON.parse(
        localStorage.getItem("CurrentInBoundCallDetails")
      );
      this.loadingFlag = true;

      var inboundPayload = {
        leadId: 0,
        remark: remark,
        CallerNumber: leadData1.patientMobileNumber.replace(/^\+91/, ""),
        isActicityLead: false,
      };
      this.callConfirmedAppointmentApi(inboundPayload);
    } else {
      this.loadingFlag = true;
      var IsActivity = localStorage.getItem("IsActivityLead");

      var outboundPayload = {
        leadId: leadData.leadId,
        remark: remark,
        CallerNumber: leadData.phoneNo,
        isActicityLead: IsActivity,
      };
      this.callConfirmedAppointmentApi(outboundPayload);
    }
  }

  private callConfirmedAppointmentApi(payload: any) {
    this.askApolloService.UpdateConfirmedAppointmentStatusEIH(payload).subscribe(
      (res: any) => {
        if (res) {
          alert("Appointment Confirmed Status Updated");
          this.messageService.showSuccess(
            res.message || "Appointment Confirmed Status Updated"
          );
          this.loadingFlag = false;
          this.confirmedAppointmentFormGroup.reset({
            remark: "Appointment confirmed",
          });
          this.commonService.setBooleanValue(false);
        } else {
          this.loadingFlag = false;
          this.messageService.showWarning("issue while updating the lead");
        }
      },
      (error) => {
        this.loadingFlag = false;
        this.messageService.showErrorMessage(
          "Unable to update confirmed appointment status, An error occur while updating status."
        );
      }
    );
  }
}
